import { forwardRef } from 'react';
import { formatStat } from '../HomeFeatures';
import { useCountUp } from '../hooks';
import './parts.css';

/* Minimal browser window around app footage. */
export function BrowserFrame({ children, className = '', url = 'app.horsestat.com' }) {
  return (
    <div className={`dm-browser ${className}`.trim()}>
      <div className="dm-browser__bar" aria-hidden="true">
        <span className="dm-browser__dots">
          <i />
          <i />
          <i />
        </span>
        <span className="dm-browser__url">{url}</span>
      </div>
      <div className="dm-browser__screen">{children}</div>
    </div>
  );
}

/* Muted inline clip. Loops unless `onEnded` is given. */
export const Clip = forwardRef(function Clip({ clip, className = '', onEnded, preload = 'metadata' }, ref) {
  return (
    <video
      ref={ref}
      className={`dm-clip ${className}`.trim()}
      muted
      playsInline
      loop={!onEnded}
      preload={preload}
      poster={clip.poster}
      onEnded={onEnded}
      aria-hidden="true"
    >
      <source src={clip.webm} type="video/webm" />
      <source src={clip.mp4} type="video/mp4" />
    </video>
  );
});

export function CountStat({ stat, run, tone }) {
  const value = useCountUp(stat.value, run, stat.value > 100 ? 1400 : 900);
  return (
    <div className="dm-stat" style={{ '--dm-tone': tone.color, '--dm-deep': tone.deep }}>
      <span className="dm-stat__value">{formatStat(value)}</span>
      <span className="dm-stat__label">{stat.label}</span>
    </div>
  );
}
